import { render, staticRenderFns } from "./SectionIntroduction.vue?vue&type=template&id=2c3d60f0&scoped=true"
import script from "./SectionIntroduction.vue?vue&type=script&lang=ts"
export * from "./SectionIntroduction.vue?vue&type=script&lang=ts"
import style0 from "./SectionIntroduction.vue?vue&type=style&index=0&id=2c3d60f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d60f0",
  null
  
)

export default component.exports